// src/components/BlockbusterDeals.jsx

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MdArrowForwardIos } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getBlockBusterDetails } from "../../redux/actions/blockbusterActions";
import { addToCartThunk } from "../../redux/actions/cartActions";
import { useNavigate } from "react-router-dom";
import { FaCartPlus, FaRegHeart } from "react-icons/fa";
import { toggleWishlistItem } from "../../redux/actions/wishlistAction";
import { Modal } from "../other";
import { toast } from "react-toastify";
import { checkStockAvailability } from "../../redux/actions/stockActions";
import { Alert } from "../common/Alert";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  A11y,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper/modules";

const BlockbusterDeals = () => {
  const dispatch = useDispatch();
  const userType = useSelector((state) => state.auth?.user?.user?.user_type);
  const {
    loading,
    deals = [],
    error,
  } = useSelector((state) => state.blockbuster);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const wishlistItems = useSelector((state) => state.wishlist.items || []);

  const [startIndex, setStartIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [subProducts, setSubProducts] = useState([]);
  const [quantities, setQuantities] = useState({});

  const navigate = useNavigate();

  const handleQuickViewClick = (product) => {
    // setSelectedProduct(product);
    navigate(`/ProductsDetails/${product.pro_id}`);
  };

  // Fetch on mount
  useEffect(() => {
    dispatch(getBlockBusterDetails());
  }, [dispatch]);

  // Auto‑scroll interval
  useEffect(() => {
    const step = Math.max(deals.length - 3, 1);
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % step);
    }, 5000);
    return () => clearInterval(interval);
  }, [deals.length]);

  // Slice out 4 visible deals
  const visible = deals.slice(startIndex, startIndex + 4);

  const slideIn = {
    hidden: { x: 100, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.5 } },
  };

  const handleAddToCartClick = (product) => {
    if (product?.SubProducts?.length) {
      setCurrentProduct(product);
      setSubProducts(product.SubProducts);

      // Initialize all sub-product quantities to 1
      const initialQuantities = {};
      product.SubProducts.forEach((sub) => {
        initialQuantities[sub.sub_pro_id] = 1;
      });
      setQuantities(initialQuantities);

      setIsModalOpen(true);
    } else {
      toast.info("No sub-products available for this item.");
    }
  };

  const incrementQuantity = (sub) => {
    const sub_product_id = sub.sub_pro_id;
    const quantity = (quantities[sub_product_id] || 1) + 1;

    // First, log what we're sending

    dispatch(checkStockAvailability(sub_product_id, quantity))
      .then((response) => {
        // Log the entire response to see its structure

        // The response structure is likely different than expected
        // The data might be directly in response.data, not in response.payload.data
        const data = response.data || {};

        // Check if there's stock available
        if (
          data.data?.status === "out_of_stock" ||
          data.data?.available_stock < data.data?.required_quantity
        ) {
          toast.info("Insufficient Stock !!!");
        } else {
          // Stock is available, increment quantity
          setQuantities((prev) => ({
            ...prev,
            [sub_product_id]: quantity,
          }));
        }
      })
      .catch((error) => {
        // Log the error for debugging

        // Display a more specific error message if available
        const errorMessage =
          error.message || "Failed to check stock. Please try again.";
        toast.error(errorMessage);
      });
  };

  const decrementQuantity = (id) => {
    setQuantities((prev) => {
      const current = prev[id] || 1;
      return {
        ...prev,
        [id]: current > 1 ? current - 1 : 1,
      };
    });
  };

  const handleAddSubProductToCart = (sub) => {
    const product_id = currentProduct.pro_id;
    const sub_product_id = sub.sub_pro_id;
    const quantity = quantities[sub_product_id] || 1;

    dispatch(checkStockAvailability(sub_product_id, quantity))
      .then((response) => {
        // Log the entire response to see its structure

        // The response structure is likely different than expected
        // The data might be directly in response.data, not in response.payload.data
        const data = response.data || {};

        // Check if there's stock available
        if (
          data.data?.status === "out_of_stock" ||
          data.data?.available_stock < data.data?.required_quantity
        ) {
          Alert.ErrorAlert("Insufficient stock!");
        } else {
          // Stock is available, increment quantity
          dispatch(
            addToCartThunk({
              product_id: product_id,
              sub_product_id,
              quantity,
            })
          );
        }
      })
      .catch((error) => {
        // Log the error for debugging

        // Display a more specific error message if available
        const errorMessage =
          error.message || "Failed to check stock. Please try again.";
        toast.error(errorMessage);
      });
  };

  return (
    <div className="container pb-6" style={{ maxWidth: "1600px" }}>
      <div className="flex justify-between items-center px-2 mb-2">
        <h2 className="text-xl mt-4 md:text-2xl lg:text-3xl xl:text-4xl font-bold mb-4">
          Blockbuster Deals
        </h2>
        {/* <div className="flex items-center gap-2">
            <button
              onClick={() =>
                setStartIndex(
                  (prev) =>
                    (prev - 1 + Math.max(deals.length - 3, 1)) %
                    Math.max(deals.length - 3, 1)
                )
              }
              className="bg-purple-600 hover:bg-purple-800 hover:scale-110 text-white rounded-full w-9 h-9 flex items-center justify-center shadow transition"
              aria-label="Previous"
            >
              <svg
                width="22"
                height="22"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M13 17l-5-5 5-5" />
              </svg>
            </button>
            <button
              onClick={() =>
                setStartIndex(
                  (prev) => (prev + 1) % Math.max(deals.length - 3, 1)
                )
              }
              className="bg-purple-600 hover:bg-purple-800 hover:scale-110 text-white rounded-full w-9 h-9 flex items-center justify-center shadow transition"
              aria-label="Next"
            >
              <svg
                width="20"
                height="22"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M7 7l5 5-5 5" />
              </svg>
            </button>
          </div> */}
      </div>

      {loading ? (
        <p className="text-center my-4">Loading deals…</p>
      ) : (
        <Swiper
          spaceBetween={24}
          slidesPerView={4}
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          scrollbar={{ draggable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            0: { slidesPerView: 2, spaceBetween: 10 },
            640: { slidesPerView: 3, spaceBetween: 15 },
            768: { slidesPerView: 4, spaceBetween: 20 },
          }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 pb-10"
        >
          {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"> */}
          {deals.map((item, idx) => {
            const isWishlisted = wishlistItems.some((wishitem) => {
              return item.pro_id == wishitem?.product?.pro_id;
            });

            return item?.SubProducts?.length > 0 ? (
              <SwiperSlide
                key={idx}
                className="cursor-pointer"
                // style={{ flex: "0 0 30%", maxWidth: "20.8333%" }}
                onClick={(e) => handleQuickViewClick(item)}
              >
                <div>
                  {item?.product_primary_img && (
                    <motion.div className="aspect-[3/4] size-full overflow-hidden rounded-3xl">
                      <img
                        loading="lazy"
                        src={item?.product_primary_img}
                        alt={item?.product_name}
                        className="size-full object-fit"
                      />
                    </motion.div>
                  )}

                  {/* <div className="home-section-quick-view-btn absolute bottom-8 left-1/2 transform -translate-x-1/2">
                  <button
                    className="btn bg-medium-theme-color text-white hover:bg-medium-theme-color rounded-pill"
                    type="button"
                    onClick={() => handleQuickViewClick(item)}
                  >
                    Quick View
                  </button>
                </div> */}

                  <div className="d-flex align-items-center justify-content-between gap-2 mt-1 flex-wrap">
                    <div className="flex flex-col flex-1 min-w-0">
                      <span className="text-truncate pb-0 fs-5 fs-6">
                        <b>{item?.product_name ?? ""}</b>
                      </span>
                      {isAuthenticated && (
                        <small className="text-red-500 font-semibold text-truncate pt-0 fw-bold -mb-2">
                          Up to{" "}
                          {user?.user_type === "vendor"
                            ? item?.SubProducts[0]?.vendor_product_margin
                            : item?.SubProducts[0]?.customer_product_discount}
                          % off
                        </small>
                      )}
                    </div>
                    {isAuthenticated && (
                      <div className="d-flex align-items-center justify-content-end">
                        <div className="px-2 py-1 text-base font-semibold rounded-xl bg-white">
                          {user?.user_type === "vendor"
                            ? item?.SubProducts[0]?.vendor_product_price
                            : item?.SubProducts[0]?.customer_product_price}
                          <span> ₹</span>
                        </div>
                        <div className="ms-1">
                          <del className="text-gray-400 text-sm">
                            {user?.user_type === "vendor"
                              ? item?.SubProducts[0]?.vendor_mrp
                              : item?.SubProducts[0]?.customer_mrp}{" "}
                            ₹
                          </del>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="position-absolute top-2 end-0 md:mr-5 mr-5 d-flex flex-column ">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(toggleWishlistItem(item.pro_id));
                      }}
                      className={`badge rounded-circle p-2 fs-6 mt-2 transition-colors opacity-100                     
                  ${
                    isWishlisted
                      ? "bg-red-500 text-white"
                      : "bg-tealish text-white"
                  }`}
                      title={
                        isWishlisted
                          ? "Remove from Wishlist"
                          : "Add to Wishlist"
                      }
                    >
                      <FaRegHeart />
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddToCartClick(item);
                      }}
                      className="badge rounded-circle bg-tealish text-white p-2 fs-6 mt-2"
                    >
                      <FaCartPlus />
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ) : null;
          })}
          {/* </div> */}
        </Swiper>
      )}

      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Select Sub Product"
        >
          <div className="flex flex-col gap-4">
            {subProducts.map((sub, idx) => (
              <div
                key={idx}
                className="w-full border rounded-xl p-4 shadow hover:shadow-lg transition flex flex-row items-center gap-4"
              >
                {/* Image on the left */}
                <img
                  loading="lazy"
                  src={sub.sub_pro_img}
                  alt={`sub-product-${idx}`}
                  className="w-32 h-44 object-cover hover:scale-110 transition-transform ease-in-out duration-500 cursor-pointer rounded-lg flex-shrink-0"
                />

                {/* Details on the right */}
                <div className="flex flex-col justify-between flex-grow h-full">
                  <div className="space-y-1">
                    <p>
                      <strong>Color:</strong> {sub.color_id}
                    </p>
                    <p>
                      <strong>Size:</strong> {sub.size}
                    </p>
                    {/* <p><strong>Location:</strong> {sub.location}</p> */}
                    {isAuthenticated ? (
                      <p>
                        <strong>Price:</strong> ₹
                        {userType === "vendor"
                          ? sub.set_price
                          : sub.customer_product_price}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>

                  {/* Quantity controls */}
                  <div className="self-start flex items-center mt-2 gap-2 ">
                    <div className="border border-gray-300 rounded-full overflow-hidden">
                      <button
                        onClick={() => decrementQuantity(sub.sub_pro_id)}
                        className="px-2 lg:px-3 py-1 bg-gray-200 hover:bg-gray-300 cursor-pointer"
                        disabled={quantities[sub.sub_pro_id] <= 1}
                      >
                        -
                      </button>
                      <span className="px-4 py-1 select-none">
                        {quantities[sub.sub_pro_id] || 1}
                      </span>
                      <button
                        onClick={() => incrementQuantity(sub)}
                        className="px-2 lg:px-3 py-1 bg-gray-200 hover:bg-gray-300 cursor-pointer"
                      >
                        +
                      </button>
                    </div>

                    {userType === "vendor" ? (
                      sub.selling_type == "set" ? (
                        <span className="ml-2">
                          {quantities[sub.sub_pro_id] <= 1 ? "Set" : "Sets"}{" "}
                        </span>
                      ) : (
                        <span className="ml-2">
                          {quantities[sub.sub_pro_id] <= 1 ? "Piece" : "Pieces"}
                        </span>
                      )
                    ) : null}
                  </div>

                  <div className="flex items-center justify-between mt-2 gap-2 flex-wrap">
                    {/* Note Text */}
                    {userType === "vendor" &&
                    sub.selling_type == "set" &&
                    sub.no_of_pcs ? (
                      <p className="italic text-sm text-red-600 font-semibold whitespace-nowrap min-w-[180px]">
                        {` ${quantities[sub.sub_pro_id] || 1} Set = ${
                          sub.no_of_pcs * (quantities[sub.sub_pro_id] || 1)
                        } pieces`}{" "}
                        (₹{sub.set_price * (quantities[sub?.sub_pro_id] || 1)})
                      </p>
                    ) : (
                      // Invisible div to take up the same space so button stays right-aligned
                      <div className="min-w-[180px]" />
                    )}

                    {/* Add Button */}
                    {isAuthenticated ? (
                      <div className="flex flex-col gap-1 w-full sm:w-fit">
                        <button
                          className="btn theme-outline-btn disabled:opacity-50 disabled:cursor-not-allowed"
                          onClick={() => handleAddSubProductToCart(sub)}
                          disabled={sub.no_of_stock <= 0}
                        >
                          Add Item
                        </button>

                        {sub.no_of_stock <= 0 && (
                          <p className="text-red-600 text-sm font-semibold">
                            Out of Stock
                          </p>
                        )}
                      </div>
                    ) : (
                      navigate("/login")
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default BlockbusterDeals;
